import { render, staticRenderFns } from "./DetailCandidature.vue?vue&type=template&id=f7f1e6d0"
import script from "./DetailCandidature.vue?vue&type=script&lang=js"
export * from "./DetailCandidature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports